<template>
  <el-card class="simple-card">
    <el-image :src="mapThumbnailUrl" class="map-thumbnail">
      <template #error>
        <div class="image-slot">
          <el-icon>
            <Picture />
          </el-icon>
        </div>
      </template>
      <template #placeholder>
        <div class="image-slot">
          <el-icon>
            <Loading />
          </el-icon>
        </div>
      </template>
    </el-image>
    <div style="padding: 5px">
      <el-text truncated>
        {{ map.name }}
      </el-text>
      <div class="bottom">
        <div>
          <el-text size="small" truncated>
            <span class="secondary-text map-by">Map by</span>
            <a class="username-link" :href="authorUrl" target="_blank">{{
              authorName
            }}</a>
          </el-text>
        </div>
        <div class="author-wrap">
          <el-image
            :src="authorAvatar"
            class="round-img"
            :style="{ visibility: authorAvatar ? 'visible' : 'hidden' }"
          />
          <el-text size="small" truncated>
            <span class="secondary-text">{{ timeAgo }}</span>
          </el-text>
        </div>
      </div>
    </div>
    <div class="btn-wrapper">
      <el-button circle size="small" v-if="map.added_to_map">
        <i
          class="iconfont icon-a-ziyuan41"
          style="color: #fc4c02"
          v-if="map.added_to_map"
        />
      </el-button>
      <el-button circle size="small" v-else @click="addToEarth">
        <i
          class="iconfont icon-a-ziyuan51"
          style="color: #fc4c02; cursor: pointer"
        />
      </el-button>
    </div>
    <el-dialog
      v-model="dialogVisible"
      v-if="!isDatahubLayer"
      :title="map.name"
      width="1000px"
      append-to-body
    >
      <iframe
        style="border: none; width: 100%; height: 600px"
        :src="map.url"
      ></iframe>
    </el-dialog>
  </el-card>
</template>
<script>
import * as Visualization from '@/carto-node/models/visualization';
import { getCartoModels } from '@/carto-node/models/CoreModels';
import { authorUrlBy, authorAvatarBy, authorNameBy, mapThumbnailUrlBy } from "@/components/utils/map";
import { has } from 'lodash';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

const { track } = useTrack();

export default {
  props: {
    map: Object,
    source: String,
  },

  data() {
    return {
      thumbnailWidth: 600,
      thumbnailHeight: 280,
      dialogVisible: false,
    };
  },

  computed: {
    // timeAgo() {
    //   return timeAgoBy(this.map);
    // },

    authorName() {
      return authorNameBy(this.map);
    },

    authorUrl() {
      return authorUrlBy(this.map);
    },

    authorAvatar() {
      return authorAvatarBy(this.map);
    },

    mapThumbnailUrl() {
      return mapThumbnailUrlBy(this.map, this.thumbnailWidth, this.thumbnailHeight);
    },

    earthLayer() {
      const earthLayer = Visualization.convert2EarthLayer(
        this.map,
        getCartoModels(),
        {
          width: this.thumbnailWidth,
          height: this.thumbnailHeight,
        },
      );
      return earthLayer;
    },

    isDatahubLayer() {
      return this.map && has(this.map, 'layerServiceInfo');
    },
  },

  methods: {
    addToEarth() {
      if (this.earthLayer.layerServiceInfo.url) {
        this.$store.dispatch(`${this.source}/addToEarth`, this.map.id);
        this.$EventBus.emit("globalcheckedLayer", this.earthLayer);
      } else {
        this.dialogVisible = true;
      }

      track(
        FunctionIdEnum.globalLayer_layers_addNewLayer,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
          name: this.map.name,
        },
      );
    },
  },
};
</script>
<style scoped>
.secondary-text {
  color: #aaa;
}
.btn-wrapper {
  position: absolute;
  top: 5px;
  right: 5px;
}

.round-img {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 1px solid #eee;
}

.author-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.5;
}

.simple-card {
  margin-bottom: 12px;
}

.username-link {
  color: #aaa;
  text-decoration: none;
}

.map-by {
  background-color: #EFEFEF;
  padding: 0 4px;
  margin-right: 4px;
  line-height: 1.5;
}
</style>

<style>
.simple-card .el-card__body {
  position: relative;
  padding: 0;
}

.map-thumbnail {
  width: 100%;
  padding-top: 46.67%;
}

.map-thumbnail .el-image__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}
</style>
